<script setup lang="ts">
definePageMeta({
  layout: 'landing',
  smoothScroll: true,
})

const { t } = useI18n()

// Labels reuse the keys LandingNav links these destinations with, so a crumb
// never disagrees with the page it points at.
const { crumbs } = useBreadcrumbs([
  { label: t('label.home'), to: '/' },
  { label: t('page.home.features') },
])

useHead({
  titleTemplate: (chunk) => chunk || 'bookforme',
  title: () => seoTitle(t, 'page.features.page_title', 'Features'),
  meta: [
    { name: 'description', content: 'Explore the powerful features of bookforme — appointment scheduling, staff management, invoicing, client tracking, and more.' },
    { property: 'og:type', content: 'website' },
    { property: 'og:title', content: () => seoTitle(t, 'page.features.page_title', 'Features') },
    { property: 'og:description', content: 'All-in-one tools to manage appointments, clients, and schedules — saving time and cutting no-shows.' },
    { property: 'og:site_name', content: 'bookforme' },
    { name: 'twitter:card', content: 'summary_large_image' },
  ],
})
</script>

<template>
  <div>
    <CommonBreadcrumbs :items="crumbs" />

    <LandingFeaturesHero />
    <LandingCoreValues />
    <LandingFeaturesShowcase />
  </div>
</template>

